import React from "react";

const EntrevistaProfesional = () => {
  return (
    <div>
      <h2>Entrevista con Profesional</h2>
      <hr />
      <p>Aquí irá el módulo de entrevistas presenciales.</p>
    </div>
  );
};

export default EntrevistaProfesional;